export default "__VITE_ASSET__Cwcr3VPj__"